import React, { useState } from 'react';
import CheckInput from './components/CheckInput';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import CustomScroll from './components/CustomScroll';
const Step4 = () => {
    //Any changes here must be duplicated in the submit-quote.asp file
    const options = [
        { key: "base", zIndex: 5, description: "Architecture structure", disabled: true },
        { key: "mep", zIndex: 3, description: "Mechanical, electrical & plumbing" },
        { key: "land", zIndex: 4, description: "Landscape civils" },
        { key: "ffe-v2", zIndex: 2, description: "Furniture, fixtures & equipment" }
    ];
    const [hoveredValue, setHoveredValue] = useState(null);
    const { watch } = useFormContext();
    const selectedValues = watch("expertise");
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "modal-grid" },
            React.createElement("div", { className: "modal-left-column" },
                React.createElement("h2", null, "Indicate required expertise"),
                React.createElement("p", null, "Indicate the relevant expertise for your project to ensure accurate and efficient support"),
                React.createElement("div", { className: "radio-grid expertise-grid" }, options.map((option, idx) => (React.createElement(CheckInput, { className: "form-check-input", id: `expertise-${idx}`, name: "expertise", label: option.description, value: option.key, key: idx, onHover: setHoveredValue, disabled: option.disabled ? true : false }))))),
            React.createElement("div", { className: "modal-right-column" },
                React.createElement("div", { className: "file-type-stack" },
                    options.sort((a, b) => a.zIndex - b.zIndex).map((option) => (React.createElement("img", { key: option.key, width: "700", height: "600", src: `/assets/images/quote-modal/expertise/${option.key}.webp`, alt: "", className: clsx("img-fluid file-image right-col-image", {
                            "d-none": (selectedValues && !selectedValues.includes(option.key)) && hoveredValue !== option.key,
                        }), loading: "lazy" }))),
                    React.createElement("img", { width: "700", height: "600", src: "/assets/images/quote-modal/expertise/base.webp", alt: "Building cross-section", className: "img-fluid file-image right-col-image", loading: "lazy" }))))));
};
export default Step4;
